import filterConstants from '../constants';

const reportsProgressPortfolio = () => ({
  id: null,
  name: null,
  type: filterConstants.FILTERS.reportsProgressPortfolio,
  properties: {
    [filterConstants.PROPERTY.gantt_id]: '',
    [filterConstants.PROPERTY.portfolio_id]: '',
    [filterConstants.PROPERTY.owner_id]: '',
    [filterConstants.PROPERTY.project_status]: '',
  },
});

export default reportsProgressPortfolio;
